import { FormVmItemConfigType } from '../form-viewmodel-controller';
import { TObject } from '../type-extensions';

type TFormConfig = Omit<FormVmItemConfigType, 'name'>;

export const buildConfigList = (formConfig: TObject<TFormConfig>): FormVmItemConfigType[] => {
    return Object.entries(formConfig).map(([key, cnf]) => ({ ...cnf, name: key }));
};
